module.exports = __webpack_public_path__ + "img/1539949363.8404bfd8.jpg";